import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { FC } from 'react';
import { CountryWithFlag } from 'ui/CountryWithFlag';
import countries from 'ui/CountryWithFlag/countries-new.json';
import { TCountrySelectProps } from './types';

export const CountrySelect: FC<TCountrySelectProps> = ({ onChange }) => {
	return (
		<Autocomplete
			sx={{ width: 300, p: '10px' }}
			size="small"
			options={countries}
			onChange={(event, newValue) => {
				if (newValue) onChange(newValue?.code);
			}}
			autoHighlight
			getOptionLabel={option => option.label}
			renderOption={(props, option) => (
				<Box component="li" {...props}>
					<Box
						sx={{
							width: '100%',
							display: 'flex',
							// flexDirection: 'row',
							justifyContent: 'space-between',
							alignItems: 'center',

							'& > div img': { mr: 2, flexShrink: 0 },
						}}
					>
						<Box>
							<CountryWithFlag countryCode={option.code} size="s" />
						</Box>
						<Box>{option.code}</Box>
					</Box>
				</Box>
			)}
			renderInput={params => (
				<TextField
					{...params}
					placeholder="Choose a country"
					inputProps={{
						...params.inputProps,
						autoComplete: 'new-password',
					}}
				/>
			)}
		/>
	);
};

interface CountryType {
	code: string;
	label: string;
	phone: string;
	suggested?: boolean;
}

// From https://bitbucket.org/atlassian/atlaskit-mk-2/raw/4ad0e56649c3e6c973e226b7efaeb28cb240ccb0/packages/core/select/src/data/countries.js
